(() => {
  const ROOT_SELECTOR = '[data-smm-bundle]';

  function init(root) {
    if (!root || root.dataset.smmReady === 'true') return;
    root.dataset.smmReady = 'true';

    const formId = root.dataset.productFormId;
    const form = document.getElementById(formId) || root.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productInfo = root.closest('product-info') || root.closest('[data-product-id]');
    const baseInput = form.querySelector('input[name="id"]');
    const submitButton = form.querySelector('[name="add"]');
    const submitLabel = submitButton?.querySelector('span');
    const nativeSubmitText = submitLabel?.textContent || '';
    const dynamicCheckout = form.querySelector('.shopify-payment-button');
    const quantityBlock = productInfo?.querySelector('.product-form__quantity');
    const originalDynamicHidden = dynamicCheckout?.hidden ?? false;
    const originalQuantityHidden = quantityBlock?.hidden ?? false;
    const currency = root.dataset.currency || 'EGP';
    const dialog = root.querySelector('[data-smm-dialog]');
    const productGrid = root.querySelector('[data-smm-products]');
    const products = Array.from(root.querySelectorAll('[data-smm-product]'));
    const builder = root.querySelector('[data-smm-builder]');
    const selectedWrap = root.querySelector('[data-smm-selected]');
    const progress = root.querySelector('[data-smm-progress]');
    const error = root.querySelector('[data-smm-error]');
    const search = root.querySelector('[data-smm-search]');
    const empty = root.querySelector('[data-smm-empty]');
    const subtotalEl = root.querySelector('[data-smm-subtotal]');
    const totalEl = root.querySelector('[data-smm-total]');
    const subtotalLabel = root.querySelector('[data-smm-subtotal-label]');
    const savingRow = root.querySelector('[data-smm-saving-row]');
    const savingEl = root.querySelector('[data-smm-saving]');
    let tier = 1;
    let activeSlot = 0;
    let extras = [];
    let submitting = false;

    let baseVariants = [];
    try {
      baseVariants = JSON.parse(root.querySelector('[data-smm-base-variants]')?.textContent || '[]');
    } catch (_) {
      baseVariants = [];
    }

    const money = (cents) => {
      const value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-EG', {
          style: 'currency', currency, maximumFractionDigits: value % 1 ? 2 : 0
        }).format(value);
      } catch (_) {
        return `${value.toFixed(2)} ${currency}`;
      }
    };

    const originalPrice = (item) => {
      const sale = Number(item?.price || 0);
      const compare = Number(item?.compareAtPrice || 0);
      return compare > sale ? compare : sale;
    };

    const getBase = () => {
      const id = String(baseInput?.value || '');
      const variant = baseVariants.find((item) => String(item.id) === id) || baseVariants.find((item) => item.available) || baseVariants[0];
      return variant ? {
        productId: String(root.dataset.baseProductId || ''),
        variantId: String(variant.id),
        variantTitle: variant.title || '',
        price: Number(variant.price || 0),
        compareAtPrice: Number(variant.compareAtPrice || 0),
        title: root.dataset.baseProductTitle || '',
        image: root.dataset.baseImage || ''
      } : null;
    };

    const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[char]));

    const setError = (message = '') => {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    };

    const priceMarkup = (item, className = '') => {
      const sale = Number(item?.price || 0);
      const original = originalPrice(item);
      const classAttr = className ? ` class="${className}"` : '';
      if (original > sale) {
        return `<span${classAttr}><s>${escapeHtml(money(original))}</s><span>${escapeHtml(money(sale))}</span></span>`;
      }
      return `<span${classAttr}>${escapeHtml(money(sale))}</span>`;
    };

    const updateProductPrices = () => {
      products.forEach((card) => {
        const priceEl = card.querySelector('[data-smm-product-price]');
        const variantSelect = card.querySelector('[data-smm-variant-select]');
        const option = variantSelect?.selectedOptions?.[0];
        if (!priceEl) return;
        const price = Number(option?.dataset.price || priceEl.dataset.originalPrice || card.dataset.maxPrice || 0);
        const compareAtPrice = Number(option?.dataset.compareAtPrice || 0);
        const original = compareAtPrice > price ? compareAtPrice : price;
        priceEl.innerHTML = original > price
          ? `<s>${escapeHtml(money(original))}</s><span>${escapeHtml(money(price))}</span>`
          : `<span>${escapeHtml(money(price))}</span>`;
      });
    };

    const itemMarkup = (item, index, isBase) => {
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="90" height="112">`
        : '<span aria-hidden="true"></span>';
      const action = isBase
        ? ''
        : `<button type="button" class="smm-bundle__change" data-smm-change="${index}">Change</button>`;
      return `<div class="smm-bundle__selected-item">${image}<div class="smm-bundle__selected-copy"><p class="smm-bundle__selected-title">${escapeHtml(item.title)}</p><p class="smm-bundle__selected-variant">${escapeHtml(item.variantTitle)}</p></div><div class="smm-bundle__selected-actions">${priceMarkup(item, 'smm-bundle__selected-price')}${action}</div></div>`;
    };

    const render = () => {
      root.dataset.tier = String(tier);
      root.querySelectorAll('[data-smm-tier]').forEach((button) => {
        const active = Number(button.dataset.smmTier) === tier;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (builder) builder.hidden = tier === 1;
      if (dynamicCheckout) dynamicCheckout.hidden = tier > 1 ? true : originalDynamicHidden;
      if (quantityBlock) quantityBlock.hidden = tier > 1 ? true : originalQuantityHidden;
      if (submitLabel) submitLabel.textContent = tier > 1 ? 'ADD BUNDLE TO CART' : nativeSubmitText;
      updateProductPrices();
      root.dispatchEvent(new CustomEvent('smm:tierchange', { bubbles: true, detail: { tier } }));

      if (tier === 1) return;
      const base = getBase();
      const requiredExtras = tier - 1;
      extras = extras.slice(0, requiredExtras);
      const chosenCount = 1 + extras.filter(Boolean).length;
      if (progress) progress.textContent = `${chosenCount} / ${tier} items selected`;
      if (subtotalLabel) subtotalLabel.textContent = `Original total (${tier} items)`;

      const markup = [];
      if (base) markup.push(itemMarkup(base, -1, true));
      for (let i = 0; i < requiredExtras; i += 1) {
        const item = extras[i];
        if (item) {
          markup.push(itemMarkup(item, i, false));
        } else {
          markup.push(`<button type="button" class="smm-bundle__choose-slot" data-smm-choose-slot="${i}">+ Choose piece ${i + 2}</button>`);
        }
      }
      if (selectedWrap) selectedWrap.innerHTML = markup.join('');

      const allItems = [base, ...extras].filter(Boolean);
      const saleTotal = allItems.reduce((sum, item) => sum + Number(item.price || 0), 0);
      const originalTotal = allItems.reduce((sum, item) => sum + originalPrice(item), 0);
      const saving = Math.max(0, originalTotal - saleTotal);

      if (subtotalEl) {
        subtotalEl.innerHTML = saving > 0
          ? `<s>${escapeHtml(money(originalTotal))}</s>`
          : escapeHtml(money(originalTotal));
      }
      if (totalEl) totalEl.textContent = money(saleTotal);
      if (savingRow) savingRow.hidden = saving <= 0;
      if (savingEl) savingEl.textContent = saving > 0 ? money(saving) : '—';
    };

    const openChooser = (slot) => {
      activeSlot = Number(slot || 0);
      setError('');
      if (search) {
        search.value = '';
        products.forEach((card) => { card.hidden = false; });
        if (empty) empty.hidden = true;
      }
      if (dialog?.showModal) {
        dialog.showModal();
        window.setTimeout(() => search?.focus(), 50);
      } else if (dialog) {
        dialog.setAttribute('open', '');
      }
    };

    const closeChooser = () => {
      if (dialog?.open && dialog.close) dialog.close();
      else dialog?.removeAttribute('open');
    };

    const reset = () => {
      tier = 1;
      extras = [];
      closeChooser();
      setError('');
      render();
    };

    root.addEventListener('click', (event) => {
      const tierButton = event.target.closest('[data-smm-tier]');
      if (tierButton) {
        tier = Number(tierButton.dataset.smmTier || 1);
        extras = extras.slice(0, Math.max(0, tier - 1));
        setError('');
        render();
        if (tier > 1 && extras.length < tier - 1) openChooser(extras.length);
        return;
      }
      if (event.target.closest('[data-smm-reset]')) { reset(); return; }
      const slotButton = event.target.closest('[data-smm-choose-slot]');
      if (slotButton) { openChooser(slotButton.dataset.smmChooseSlot); return; }
      const changeButton = event.target.closest('[data-smm-change]');
      if (changeButton) { openChooser(changeButton.dataset.smmChange); return; }
      if (event.target.closest('[data-smm-dialog-close]')) { closeChooser(); return; }
      const selectButton = event.target.closest('[data-smm-select]');
      if (selectButton) {
        const card = selectButton.closest('[data-smm-product]');
        const variantSelect = card?.querySelector('[data-smm-variant-select]');
        const option = variantSelect?.selectedOptions?.[0];
        if (!card || !option?.value) return;
        extras[activeSlot] = {
          productId: String(card.dataset.productId || ''),
          variantId: String(option.value),
          variantTitle: option.dataset.title || option.textContent || '',
          price: Number(option.dataset.price || 0),
          compareAtPrice: Number(option.dataset.compareAtPrice || 0),
          title: card.dataset.productTitle || '',
          image: card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || ''
        };
        closeChooser();
        render();
        return;
      }
    });

    root.addEventListener('smm:reset', reset);

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-smm-variant-select]')) updateProductPrices();
    });

    search?.addEventListener('input', () => {
      const needle = search.value.trim().toLowerCase();
      let visible = 0;
      products.forEach((card) => {
        const matches = !needle || (card.dataset.productSearch || '').includes(needle);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    });

    productInfo?.addEventListener('change', () => {
      if (tier > 1) window.setTimeout(render, 0);
    });

    if (productGrid) {
      products.sort((a, b) => Number(b.dataset.maxPrice || 0) - Number(a.dataset.maxPrice || 0));
      products.forEach((card) => productGrid.appendChild(card));
    }

    form.addEventListener('submit', async (event) => {
      if (tier === 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting) return;
      const base = getBase();
      const requiredExtras = tier - 1;
      if (!base?.variantId || baseInput?.disabled) {
        setError('Please choose an available option for the main product.');
        return;
      }
      if (extras.filter(Boolean).length !== requiredExtras) {
        setError(`Choose ${requiredExtras} extra ${requiredExtras === 1 ? 'piece' : 'pieces'} to complete your bundle.`);
        openChooser(extras.findIndex((item) => !item));
        return;
      }

      setError('');
      submitting = true;
      const originalDisabled = submitButton?.disabled;
      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = 'ADDING BUNDLE…';
      submitButton?.classList.add('loading');

      const bundleId = `smm-${Date.now()}-${window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`;
      const rawItems = [base, ...extras];
      const items = rawItems.map((item, index) => ({
        id: Number(item.variantId),
        quantity: 1,
        properties: {
          '_Bundle ID': bundleId,
          '_Bundle Size': `${tier} pieces`,
          '_Bundle Slot': index === 0 ? 'base-1' : `extra-${index}`
        }
      }));
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = { items };
      if (cart?.getSectionsToRender) {
        const sections = cart.getSectionsToRender().map((section) => section.id);
        if (sections.length) {
          payload.sections = sections.join(',');
          payload.sections_url = window.location.pathname;
        }
        cart.setActiveElement?.(document.activeElement);
      }

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add bundle.');
        if (cart?.renderContents && data.sections) {
          cart.renderContents(data);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }
      } catch (err) {
        setError(err?.message || 'Unable to add the bundle. Please try again.');
      } finally {
        submitting = false;
        submitButton?.classList.remove('loading');
        if (submitButton) submitButton.disabled = Boolean(originalDisabled);
        if (submitLabel) submitLabel.textContent = tier > 1 ? 'ADD BUNDLE TO CART' : nativeSubmitText;
      }
    }, true);

    render();
  }

  const initAll = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
